import React from "react";
import PropTypes from "prop-types";
import { Image } from "@sparefoot/react-commons";
import { H1, Text } from "components/core/Typography";
import { CircleArrow } from "components/core/Icons";
import img from "assets/images/clp-header-image.svg";

import SearchBar from "components/search/SearchBar/SearchBar";
import "./CLPHeroVariation.scss";
import { PaidLandingHeroContent } from "components/sdc/PaidLanding/PaidLandingHeroContent";

function CLPHeroVariation({ heroPromoExperimentVariation }) {
	// sf_14850_hero_promo_test_sdc
	const { pillText, heading, description, bottomText } =
		PaidLandingHeroContent[heroPromoExperimentVariation] ||
		PaidLandingHeroContent?.control;

	const linkButtonsData = [
		"Compare nearby storage facilities",
		"Find exclusive deals and pricing",
		"Reserve storage online for free"
	];
	return (
		<div className="clp-header">
			{pillText && (
				<div className="header-pill">
					<Text
						size="medium"
						color="white"
						weight="bold"
					>
						{pillText}
					</Text>
				</div>
			)}

			<div className="searchbar-container">
				<H1
					className="heading"
					color="darkBlue"
					weight="bold"
				>
					{heading}
				</H1>
				<Text
					className="desc-text"
					size="large"
					color="gray"
				>
					{description}
				</Text>

				<SearchBar
					buttonText="Find Storage"
					id="paid-hero-search-bar"
					label="Search by city, state, or zip"
					theme="darkBlue"
					className="searchbar"
				/>

				{bottomText ? (
					<>
						<Text
							size="tiny"
							weight="bold"
							className="text"
							color="gray"
						>
							{bottomText.start}
							<Text color="lightBlue"> {bottomText.middle}</Text>
							{bottomText.end}
						</Text>
					</>
				) : (
					<Text
						className="link-buttons"
						size="small"
						color="gray"
					>
						{linkButtonsData.map((data) => (
							<Text>
								<CircleArrow
									fill="gray"
									size="xlarge"
								/>
								{data}
							</Text>
						))}
					</Text>
				)}
			</div>
			<Image
				src={img}
				alt="clp-header-img"
			/>
		</div>
	);
}

CLPHeroVariation.propTypes = {
	heroPromoExperimentVariation: PropTypes.string
};

export default CLPHeroVariation;
